import "./dashboard-sections.css";

const Shimmer = ({ h = 16, w = "100%", mb = 0 }) => (
  <div
    className="db-shimmer"
    style={{ height: h, width: w, marginBottom: mb }}
  />
);

export const ShimmerMetricRow = ({ count = 5 }) => (
  <div className="db-shimmer-metric-row">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="db-shimmer-card">
        <Shimmer h={11} w="55%" />
        <Shimmer h={30} w="75%" />
      </div>
    ))}
  </div>
);

export const ShimmerTwoCol = () => (
  <div className="db-two-col">
    {[0, 1].map((i) => (
      <div key={i} className="db-avg-card">
        <div className="db-avg-header">
          <Shimmer h={16} w="45%" />
        </div>
        {[0, 1, 2, 3].map((j) => (
          <div key={j} className="db-avg-row">
            <Shimmer h={13} w="40%" />
            <Shimmer h={13} w="18%" />
          </div>
        ))}
      </div>
    ))}
  </div>
);
